<div class="row" *ngIf="tipoPraticaSugg">
  <div class="col-12" *ngIf="tipiPraticaOptions">
    <p>Tipo pratica suggerito: <strong>{{formatLabel(tipoPraticaSugg)}}</strong></p>
  </div>
</div>
<div *ngIf="tipiPraticaOptions && tipiPraticaOptions.length != 2" class="row">
  <div class="btn-group blocks col-sm-12">
    <p class="col-xs-12 col-sm-4 tipo-fascicolo" *ngFor="let itemPratica of tipiPraticaOptions; let i = index">
      <button class="btn btn-primary item-pratica-{{itemPratica.endpoint}}" (click)="setTipoPratica(itemPratica)">
        {{itemPratica.descrizione}}
      </button>
    </p>
  </div>
</div>

<div *ngIf="tipiPraticaOptions && tipiPraticaOptions.length === 2" class="row">
  <div class="btn-group blocks col-sm-12">
    <p class="col-xs-12 col-sm-6 tipo-fascicolo" *ngFor="let itemPratica of tipiPraticaOptions; let i = index">
      <button class="btn btn-primary item-pratica-{{itemPratica.endpoint}}" (click)="setTipoPratica(itemPratica)">
        {{itemPratica.descrizione}}
      </button>
    </p>
  </div>
</div>
